import { createClient } from '@supabase/supabase-js';
import type { Database } from './types.ts';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL) {
    throw new Error("Missing VITE_SUPABASE_URL");
}
if (!SUPABASE_PUBLISHABLE_KEY) {
    throw new Error("Missing VITE_SUPABASE_PUBLISHABLE_KEY");
}

const noopStorage = {
    getItem: async () => null,
    setItem: async () => { },
    removeItem: async () => { },
};

const customFetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const headers = new Headers(init?.headers);

    if (import.meta.env.DEV) {
        console.log("[PublicClient] Before strip:", input.toString(), "Has Auth:", headers.has("Authorization") || headers.has("authorization"));
    }

    // Explicitly remove authorization to prevent 401/403 RLS errors on public tables
    headers.delete("Authorization");
    headers.delete("authorization");

    if (import.meta.env.DEV) {
        console.log("[PublicClient] After strip:", input.toString(), "Has Auth:", headers.has("Authorization") || headers.has("authorization"));
    }

    return fetch(input, { ...init, headers });
};

/*
  Dedicated public client for unauthenticated reads.
  Never persists or uses session, ensuring queries run as 'anon' role
  to bypass RLS policies that restrict 'authenticated' users to their own org.
*/
export const supabasePublic = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
        storageKey: "sb-public-noauth",
        storage: noopStorage as any,
    },
    global: {
        fetch: customFetch,
        headers: {
            apikey: SUPABASE_PUBLISHABLE_KEY
        }
    }
});
